import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAdmins } from 'slice/userSlice';
import AdminTable from 'common/AdminTable';
import { Link } from 'react-router-dom';

const List = () => {
    const dispatch = useDispatch();
    const { response, loading } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getAdmins());
    }, [dispatch]);

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Name', accessor: 'name' },
        { Header: 'Username', accessor: 'username' },
        { 
            Header: 'Status', 
            accessor: 'isActive',
            Cell: ({ value }) => (
                <span className={`badge ${value ? 'badge-success' : 'badge-danger'}`}>
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { Header: 'Last Login', accessor: 'lastLogin' },
        { Header: 'Created At', accessor: 'createdAt' },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Administrators</h4>
                <Link to="/khajuraho/admins/add" className="btn btn-light btn-sm font-weight-bold">Add New Admin</Link>
            </div>
            <div className="mt-4">
                {loading ? (
                    <div className="text-center text-white">Loading...</div>
                ) : (
                    response?.data ? (
                        <AdminTable tableHeaders={tableHeaders} tableData={response.data} />
                    ) : (
                        <div className="text-center text-white">No admins found or error loading data.</div>
                    )
                )}
            </div>
        </div>
    );
};

export default List;
